import { RolesWithPermissions } from './types/roles-with-permissions';

// access control matrix
// where the magic happens!
// the one place where you control all system permissions

export const ABAC = {
  admin: {},

  sales_representative: {
    contacts: {
      get_messages: (user, contact) => user.id === contact.assignedTo,

      send_message: (user, contact) => user.id === contact.assignedTo,
    },

    communication_module: {
      access: true,
    },
  },

  sales_manager: {
    contacts: {
      get_messages: true,
      send_message: true,
    },
  },
} as const satisfies RolesWithPermissions;
